import React from "react";

function DownArrow() {
  return (
    <>
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
        <path
          d="M1 1.5L6 6.5L11 1.5"
          stroke="#6B7280"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export default DownArrow;
